import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { IconCalendarHeart02 } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";

import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

import { URLS } from "@constants/urls";

const { SETTINGS } = URLS;

export const LeaveListPageHeader = () => {
  const { t } = useTranslation();

  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const breadcrumbs = [
    {
      icon: <IconCalendarHeart02 fill="dark" size="20" />,
    },
    {
      label: t("LEAVE_LIST.BREADCRUMBS.FIRST_STEP"),
    },
  ];

  const headerText = {
    header: t("LEAVE_LIST.HEADING"),
    subHeader: t("LEAVE_LIST.DESCRIPTION"),
  };

  const actions = [
    <Link to={SETTINGS}>
      <Button fill="fill" size="sm" type="info" htmlType="button">
        {t("LEAVE_LIST.SETTINGS_BUTTON")}
      </Button>
    </Link>,
  ];

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs}
      actions={getAccess(roles, "LEAVE_SETTINGS_UPDATE") ? actions : undefined}
    />
  );
};
